import {createEntitySlice} from 'utils/createEntitySlice';
import {BillingRule} from 'types/billingRule';
import {BillingRulesThunks} from 'features/programs/program/billingRules/billingRulesThunks';

export interface BillingRulesState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  billingRules?: BillingRule[];
  pagy?: any;
  billingRule?: BillingRule | null;
  isEditing?: boolean;
}

const initialState: BillingRulesState = {
  status: 'idle',
  error: null,
  billingRules: [],
  billingRule: null,
  pagy: {},
  isEditing: false,
};

const billingRulesSlice = createEntitySlice<BillingRule>({
  name: 'Billing Rule',
  initialState,
  thunks: BillingRulesThunks,
  entityKey: 'billingRule',
  entitiesKey: 'billingRules',
  reducers: {},
});

export const {setEntity: setBillingRule, setIsEditing} =
  billingRulesSlice.actions;
export {initialState as billingRulesInitialState};
export default billingRulesSlice.reducer;
